import { createFileRoute } from "@tanstack/react-router";
import { ClientPricingDocumentPage } from "../../../../../features/client-pricing-document/client-pricing-document-page";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/client-pricing-document")({
  component: ClientPricingDocumentRoute,
});

function ClientPricingDocumentRoute() {
  const { dealId } = Route.useParams();
  return <ClientPricingDocumentPage dealId={dealId} />;
}
